import React from 'react';
import { Link } from 'react-router-dom';
import './Animation.css';

function Animation() {
  return (
    <div className="animation-page">
      <header className="services-header">
        <h2>Our Services</h2>
        <nav className="services-nav">
          <a href="#2d-animation">2D Animation</a>
          <a href="#3d-animation">3D Animation</a>
          <a href="#commercial-production">Commercial Production</a>
          <a href="/hire-developer">Software Development</a>
        </nav>
      </header>

      <section className="intro-section">
        <h1>Animation Services</h1>
        <p>Bring your vision to life with our premium animation services. Choose between 2D and 3D Animation, available in Silver, Gold, and Platinum packages tailored to your project's scope.</p>
      </section>

      <section id="2d-animation" className="service-category">
        <h2>2D Animation Packages</h2>
        <p className="category-desc">From motion graphics and explainers to detailed character animation. (Detailed frame-by-frame animation may require a custom quote).</p>
        <div className="pricing-cards">
          <div className="pricing-card silver">
            <h3>Silver</h3>
            <p className="price">Starting at $1,000+</p>
            <ul>
              <li><strong>Best for:</strong> Simple promotional video</li>
              <li><strong>Length:</strong> Up to 15 seconds</li>
              <li><strong>Creative scope:</strong> Simple concept and backgrounds</li>
              <li><strong>Revision rounds:</strong> 1</li>
              <li><strong>Delivery formats:</strong> One aspect ratio</li>
              <li><strong>Extra deliverables:</strong> —</li>
              <li><strong>Sound:</strong> Basic sound design</li>
            </ul>
            <div className="card-actions">
              <Link to="/animation-gallery" className="btn-view" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>View Examples</Link>
              <Link to="/animation-quote" className="btn-quote" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>Request a Quote</Link>
            </div>
          </div>
          
          <div className="pricing-card gold">
            <div className="recommended-badge">Most Popular</div>
            <h3>Gold</h3>
            <p className="price">Starting at $2,500+</p>
            <ul>
              <li><strong>Best for:</strong> Custom brand commercial</li>
              <li><strong>Length:</strong> Up to 30 seconds</li>
              <li><strong>Creative scope:</strong> Custom storyboard and multiple scenes</li>
              <li><strong>Revision rounds:</strong> 2</li>
              <li><strong>Delivery formats:</strong> Horizontal and vertical</li>
              <li><strong>Extra deliverables:</strong> One short cutdown</li>
              <li><strong>Sound:</strong> Sound design and licensed music</li>
            </ul>
            <div className="card-actions">
              <Link to="/animation-gallery" className="btn-view" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>View Examples</Link>
              <Link to="/animation-quote" className="btn-quote" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>Request a Quote</Link>
            </div>
          </div>

          <div className="pricing-card platinum">
            <h3>Platinum</h3>
            <p className="price">Starting at $5,000+</p>
            <ul>
              <li><strong>Best for:</strong> Detailed campaign production</li>
              <li><strong>Length:</strong> Up to 60 seconds</li>
              <li><strong>Creative scope:</strong> Detailed storyboard, advanced scenes and effects</li>
              <li><strong>Revision rounds:</strong> 3</li>
              <li><strong>Delivery formats:</strong> Horizontal, vertical, and square</li>
              <li><strong>Extra deliverables:</strong> Two short cutdowns</li>
              <li><strong>Sound:</strong> Expanded sound design; voiceover quoted separately</li>
            </ul>
            <div className="card-actions">
              <Link to="/animation-gallery" className="btn-view" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>View Examples</Link>
              <Link to="/animation-quote" className="btn-quote" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>Request a Quote</Link>
            </div>
          </div>
        </div>
      </section>

      <section id="3d-animation" className="service-category">
        <h2>3D Animation Packages</h2>
        <p className="category-desc">High-end 3D modeling, texturing, and animation. (Complex 3D simulations or custom characters quoted separately).</p>
        <div className="pricing-cards">
          <div className="pricing-card silver">
            <h3>Silver</h3>
            <p className="price">Starting at $1,500+</p>
            <ul>
              <li><strong>Best for:</strong> Simple promotional video</li>
              <li><strong>Length:</strong> Up to 15 seconds</li>
              <li><strong>Creative scope:</strong> Simple concept and backgrounds</li>
              <li><strong>Revision rounds:</strong> 1</li>
              <li><strong>Delivery formats:</strong> One aspect ratio</li>
              <li><strong>Extra deliverables:</strong> —</li>
              <li><strong>Sound:</strong> Basic sound design</li>
            </ul>
            <div className="card-actions">
              <Link to="/animation-gallery" className="btn-view" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>View Examples</Link>
              <Link to="/animation-quote" className="btn-quote" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>Request a Quote</Link>
            </div>
          </div>
          
          <div className="pricing-card gold">
            <div className="recommended-badge">Most Popular</div>
            <h3>Gold</h3>
            <p className="price">Starting at $3,500+</p>
            <ul>
              <li><strong>Best for:</strong> Custom brand commercial</li>
              <li><strong>Length:</strong> Up to 30 seconds</li>
              <li><strong>Creative scope:</strong> Custom storyboard and multiple scenes</li>
              <li><strong>Revision rounds:</strong> 2</li>
              <li><strong>Delivery formats:</strong> Horizontal and vertical</li>
              <li><strong>Extra deliverables:</strong> One short cutdown</li>
              <li><strong>Sound:</strong> Sound design and licensed music</li>
            </ul>
            <div className="card-actions">
              <Link to="/animation-gallery" className="btn-view" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>View Examples</Link>
              <Link to="/animation-quote" className="btn-quote" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>Request a Quote</Link>
            </div>
          </div>

          <div className="pricing-card platinum">
            <h3>Platinum</h3>
            <p className="price">Starting at $7,500+</p>
            <ul>
              <li><strong>Best for:</strong> Detailed campaign production</li>
              <li><strong>Length:</strong> Up to 60 seconds</li>
              <li><strong>Creative scope:</strong> Detailed storyboard, advanced scenes and effects</li>
              <li><strong>Revision rounds:</strong> 3</li>
              <li><strong>Delivery formats:</strong> Horizontal, vertical, and square</li>
              <li><strong>Extra deliverables:</strong> Two short cutdowns</li>
              <li><strong>Sound:</strong> Expanded sound design; voiceover quoted separately</li>
            </ul>
            <div className="card-actions">
              <Link to="/animation-gallery" className="btn-view" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>View Examples</Link>
              <Link to="/animation-quote" className="btn-quote" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block'}}>Request a Quote</Link>
            </div>
          </div>
        </div>
      </section>

      <section id="commercial-production" className="service-category additional-services">
        <h2>Commercial Production & Additional Services</h2>
        <table className="services-table">
          <thead>
            <tr>
              <th>Service</th>
              <th>Proposed Website Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Brand customization of an existing commercial</td>
              <td>Starting at $1,500</td>
            </tr>
            <tr>
              <td>Custom 30-second 3D product commercial</td>
              <td>Starting at $3,500</td>
            </tr>
            <tr>
              <td>Cinematic commercial with multiple scenes or complex effects</td>
              <td>Starting at $7,500</td>
            </tr>
            <tr>
              <td>Exclusive campaigns or larger brand projects</td>
              <td>Request a quote</td>
            </tr>
          </tbody>
        </table>
        <div className="custom-proposal-banner">
          <h3>Need something different?</h3>
          <p>Don't see a package that fits? Let's build a solution tailored to your goals.</p>
          <Link to="/animation-quote" className="btn-quote-large" style={{textDecoration: 'none', textAlign: 'center', display: 'inline-block', marginTop: '20px'}}>Request a Custom Proposal</Link>
        </div>
      </section>

      <section className="terms-section">
        <div className="terms-grid">
          <div className="term-box">
            <h3>Revisions Defined</h3>
            <p>A revision round is one consolidated list of changes within the approved scope. A new concept, added scenes, or a changed script after approval is additional work. Approve the storyboard before animation starts to avoid expensive rework.</p>
          </div>
          <div className="term-box">
            <h3>Exclusions & Add-ons</h3>
            <p>Advertising spend, exclusivity rights, source files, and additional licensing are quoted separately. Delivery formats and usage rights are defined in each proposal.</p>
          </div>
          <div className="term-box specials">
            <h3>Current Specials</h3>
            <ul>
              <li>Include a vertical version for social media.</li>
              <li>Include a 10-second cutdown alongside the 30-second commercial.</li>
              <li>Offer a limited introductory discount on clearly defined packages.</li>
              <li>Offer a repeat-client or multi-video package discount.</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Animation;
